import { useForm } from "react-hook-form";
import { TextFieldComponent } from "../../../common/TextFieldComponent";
import { Box, Button, Grid, Typography } from "@mui/material";
import { postProvider } from "../helpers/postProvider";
import { useModals } from "../../../../context/ModalContext";

const REGEX_LETTERS_ONLY = /^[A-Za-zÀ-ÿ0-9\s]+$/;

export const AddProvider = ({ modalKey, onSuccess, onClose }) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm({
    mode: "onChange", // valida mientras escribe
  });

  const token = sessionStorage.getItem("token");
  const { closeByKey } = useModals();

  const onSubmit = async (data) => {
    try {
      await postProvider({
        token,
        data: { name: data.nameProvider, address: data.addressProvider },
      });
      // primero notifica éxito (esto refresca la tabla en tu parent)
      onSuccess?.();
      // luego cierra el modal
      closeByKey(modalKey);
      // (opcional) onClose si lo usas en algún lado
      onClose?.();
    } catch (error) {
      console.log(error);
      // aquí podrías mostrar un snackbar de error si quieres
    }
  };

  return (
    <Box sx={{ padding: "15px" }}>
      <Typography variant="h4" sx={{ marginBottom: "30px" }}>
        Add Provider
      </Typography>

      <Box
        id="provider-form-info"
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-evenly",
          width: "100%",
        }}
      >
        <Grid container spacing={2}>
          <Grid item md={12}>
            <TextFieldComponent
              name="nameProvider"
              errors={errors}
              register={register("nameProvider", {
                required: { value: true, message: "Name is required" },
                minLength: { value: 3, message: "Minimum of three characters" },
                pattern: { value: REGEX_LETTERS_ONLY, message: "Only letters are allowed" },
              })}
              label="Provider Name"
              inputLabel="Provider Name"
              type="text"
            />
          </Grid>

          <Grid item md={12}>
            <TextFieldComponent
              name="addressProvider"
              errors={errors}
              register={register("addressProvider", {
                required: { value: true, message: "Provider Address is required" },
                minLength: { value: 3, message: "Minimum of three characters" },
                pattern: { value: /^[A-Za-zÀ-ÿ0-9\s.,#°\-]+$/, message: "Only alphanumeric characters are allowed" },
              })}
              label="Address Provider"
              inputLabel="Address Provider"
              type="text"
            />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          type="submit"
          disabled={!isValid || isSubmitting}
          sx={{
            mt: 2,
            px: 3,
            py: 1.25,
            borderRadius: 2,
            backgroundColor: "#0f188d",
            textTransform: "none",
            fontWeight: 700,
            "&:hover": { backgroundColor: "#0d1477" },
          }}
        >
          {isSubmitting ? "Saving..." : "Add"}
        </Button>
      </Box>
    </Box>
  );
};
